export default function (_a) {
    var data = _a.data, outputs = _a.outputs, inputs = _a.inputs;
    inputs['get'](function (val, relOutpus) {
        var nowVal = data.val !== void 0 ? data.val : data.initValue;
        var cv = clone(nowVal);
        relOutpus['return'](cv);
    });
    inputs['set'](function (val, relOutpus) {
        data.val = val;
        var cVal = clone(val);
        outputs['changed'](cVal, true); //notify all forked coms
        // relOutpus['return'](cVal);
    });
    inputs['reset'](function () {
        var val = data.initValue;
        data.val = val;
        outputs['changed'](clone(val), true); //notify all forked coms
    });
}
function clone(val) {
    if (val && typeof val === 'object') {
        try {
            if (val instanceof FormData) {
                return val;
            }
            return JSON.parse(JSON.stringify(val));
        }
        catch (ex) {
            return val;
        }
    }
    return val;
}
